/**
 * My API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ReportCurrent } from './reportCurrent';


export interface ReportMachineStarts { 
    total?: ReportCurrent;
}

